import React from 'react';
import { motion } from 'framer-motion';
import { HiPlus, HiSparkles, HiVideoCamera } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

/**
 * CreateAvatarVideoCard Component
 * 
 * Ghost card button to trigger avatar video creation
 * Redirects to /ai-avatars-create
 */
const CreateAvatarVideoCard = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/ai-avatars-create');
    };

    return (
        <motion.button
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleClick}
            className="group relative bg-transparent border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-3xl p-8 hover:border-purple-400 dark:hover:border-purple-500 hover:bg-gradient-to-br hover:from-purple-50/50 hover:to-pink-50/50 dark:hover:from-purple-900/10 dark:hover:to-pink-900/10 transition-all duration-300 flex flex-col items-center justify-center gap-4 aspect-[9/16]"
        >
            <motion.div
                whileHover={{ rotate: 90 }}
                transition={{ duration: 0.3 }}
                className="w-20 h-20 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 group-hover:from-purple-100 group-hover:to-pink-100 dark:group-hover:from-purple-900/30 dark:group-hover:to-pink-900/30 flex items-center justify-center transition-all duration-300 shadow-md group-hover:shadow-lg"
            >
                <HiPlus className="text-4xl text-gray-400 dark:text-gray-600 group-hover:text-purple-500 transition-colors duration-200" />
            </motion.div>
            
            <div className="text-center space-y-1">
                <p className="text-base font-bold text-gray-700 dark:text-gray-300 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors flex items-center justify-center gap-2">
                    <HiVideoCamera className="text-lg" />
                    Create Avatar Video
                    <HiSparkles className="text-sm transition-opacity" />
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-200 transition-colors">
                    Generate a new AI avatar video
                </p>
            </div>
        </motion.button>
    );
};

export default CreateAvatarVideoCard;

